import { render, staticRenderFns } from "./DealersManagerList.vue?vue&type=template&id=0bff26a8&"
import script from "./DealersManagerList.vue?vue&type=script&lang=js&"
export * from "./DealersManagerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports